import Player from '@vimeo/player';

const toDataUrl = async function (item, callback) {
   //Convert to base64
   let url = item.url;
   return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
         var reader = new FileReader();
         reader.onloadend = function () {
            resolve(reader.result);
         };
         reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = () => {
         $(item).remove();
         reject({
            // status: this.status,
            statusText: xhr.statusText,
         });
      };
      xhr.open("GET", url);
      xhr.withCredentials = true;
      xhr.responseType = "blob";
      xhr.send();
   });
};

export default class Entry {
   constructor(row, headers) {
      const t = this;

      this.fetchedBibliography = [];

      for (var i = 0; i < headers.length; i++) {
         let key = headers[i];
         key = key.replace(/[^a-zA-Z0-9\s]+/g, '').replaceAll(' ', '-').toLowerCase();
         this[key] = row.data[i];
         if (this['type']) {
            // console.log(this.type, this.title);
            this._cat = this['type'];
            // category;
            if (key == 'type') {
               // console.log(row.data[i], row);
            }
         }
         // this.prototype[headers[i]] = this.data[i];
      }

      this.relatedBoxes = [];
      window.relators = [];

      // if(this['status'] !== 'Draft') {
      //    this.createBlock();
      // } else {
      //    console.log(`DRAFT: "${this['title']}" - skipping`);
      // }
      this.closeRelateds = this.closeRelateds.bind(this);
      this.clearRelateds = this.clearRelateds.bind(this);
      this.alignRelatedBoxes = this.alignRelatedBoxes.bind(this);
      // this.drawLine = this.drawLine.bind(this);
   }

   createBlock(idx) {
      const t = this;
      // if($(`.boxes.${this._cat}`).length==0){
      //    if(this._cat) {
      //       $('main').append(`<content class='boxes ${this._cat}'><div class='boxes-inner'><div class='box-backdrop'></div></div></content>`);
      //       $('nav.cats').prepend(`<a href='#${this._cat}'>${this._cat}</a>`);
      //    }
      // }

      let boxCss = '';
      let boxClass = '';

      let title = '';
      let authors = '';
      let figure = '';
      let embed = '';
      let sources = [];
      let sourcesObj = {};
      let sourcesResult = null;
      let isbn_dois = [];
      let relateds = [];
      let relatedSlugs = [];
      let strengths = [];
      let year = '';
      let medialink = '';
      let figcaption = '';

      let creatorsObj = {};
      let creatorsResult = [];

      window.mouseovers = [];
      window.mouseleaves = [];

      // console.log(this);

      title =
         this['title'] ||
         this['concept-bold-text-represents-key-concepts'] ||
         this['artwork-title'] ||
         this['concept-name'];

      var important = this['important'] == 'Y';
      if (this['status'] == 'Draft') important = false;
      if (!important) boxClass += 'unimportant';
      if (!important) return false;

      if (!title) return false;

      Object.keys(this).forEach(key => {
         if (key.indexOf('description') >= 0) {
            this.description = this[key];
         }

         if (key.indexOf('author') == 0) {
            if (this[key]) {
               if (authors) authors += ', ';
               authors += this[key];
            }
         }

         if (key.indexOf('year') == 0) {
            if (this[key]) {
               if (year) year += ', ';
               year += this[key];
            }
         }

         // if (key.startsWith("source-") && key.indexOf('full-note')>=0) {
         if (key.startsWith("source") && key.indexOf('mhra') >= 0) {
            if (this[key]) {
               // console.log(`this`,key, this[key]);
               // sources.push(this[key]);
               // example: source-1-mhra
               let number = key.match(/\d+/) ? key.match(/\d+/)[0] : null;

               let parsed = t.parseBibliographyEntry(this[key]);
               sources[number] = parsed;
            }
         }


         /*
         if (key.startsWith("source-") && key.indexOf('author')>=0) {
            // console.log(key);
            const parts = key.split("-");
            const sourceIndex = parts[1];
            const authorIndex = parts[3];
            const namePart = parts[4]; // 'first' or 'last'
            const value = this[key];

            if(!value) return;

            // console.log(parts);
            
            if (!sourcesObj[sourceIndex]) {
               sourcesObj[sourceIndex] = [];
            }
            
            if (!sourcesObj[sourceIndex][authorIndex - 1]) {
               sourcesObj[sourceIndex][authorIndex - 1] = { firstName: "", lastName: "" };
            }
            
            if (namePart === "first") {
               sourcesObj[sourceIndex][authorIndex - 1].firstName = value;
            } else if (namePart === "last") {
               sourcesObj[sourceIndex][authorIndex - 1].lastName = value;
            }

            sourcesResult = Object.keys(sourcesObj).map(sourceIndex => ({
               source: `Source ${sourceIndex}`,
               authors: sourcesObj[sourceIndex]
            }));

            // console.log('sourcesObj', sourcesResult);
         } else if (key.indexOf('source-')==0) {
            if(this[key]) {
              console.log(`this`,key, this[key]);
               sources.push(this[key]);
            }
         }
         */

         this.sources = sources;

         if (key.indexOf('isbn-doi') == 0) {
            if (this[key]) {
               let number = key.match(/\d+/) ? key.match(/\d+/)[0] : null;
               isbn_dois[number] = this[key];
            }
         }

         this.isbn_dois = isbn_dois;

         if (key.indexOf('related') == 0) {
            if (this[key] && this[key].length > 0) {
               relateds.push(this[key]);

               let relatedSlug = this[key];
               // console.log(relatedSlug);
               // relatedSlug = relatedSlug.toLowerCase().replaceAll(' ','-').replaceAll('.','').replaceAll(',','').replaceAll(':','').replaceAll(';','').replaceAll('!','').replaceAll('?','').replaceAll('(','').replaceAll(')','').replaceAll('/','').replaceAll('"','').replaceAll("'",'').replaceAll('&','').replaceAll('’','').replaceAll('‘','').replaceAll('“','').replaceAll('”','').replaceAll('—','-').replaceAll('–','-');
               relatedSlug = slugify(relatedSlug);
               relatedSlugs.push(relatedSlug);
               // also get strength value
               // "strength 1" is for "related concept 1"
            }
         }
         if (key.toLowerCase().indexOf('strength') == 0) {
            if (this[key]) {
               strengths.push(this[key]);
            }
         }

         if (key.indexOf('media-link') == 0) {
            if (this[key]) {
               medialink += this[key];
            }
         }

         if (key.startsWith("creator-")) {
            const parts = key.split("-");
            const creatorIndex = parts[1];       // "1"
            const namePart = parts[2];           // "first" or "last"
            const value = this[key];             // actual name

            if (!value) return;

            if (!creatorsObj[creatorIndex]) {
               creatorsObj[creatorIndex] = { firstName: "", lastName: "" };
            }

            if (namePart === "first") {
               creatorsObj[creatorIndex].firstName = value;
            } else if (namePart === "last") {
               creatorsObj[creatorIndex].lastName = value;
            }

            // Convert object to array if needed:
            creatorsResult = Object.keys(creatorsObj).map(index => creatorsObj[index]);
         }
      });

      let creatorsResultHtml = '';
      if (creatorsResult) {
         creatorsResult.forEach((creator, i) => {
            if (creator.firstName || creator.lastName) {
               creatorsResultHtml += `<span class='source-author'>${creator.firstName} ${creator.lastName}</span>`;
            }
         });
      }

      this._relateds = relateds;
      this._relatedSlugs = relatedSlugs;
      this._strengths = strengths;

      // mostly replace AUTHORS with ISBN/DOI
      // if(this['isbn'] || this['doi']) {
      //    authors = '';
      //    if(this['isbn']) authors += `<a href='https://www.worldcat.org/isbn/${this['isbn']}' target='_blank'>ISBN: ${this['isbn']}</a>`;
      //    if(this['doi']) authors += `<a href='https://doi.org/${this['doi']}' target='_blank'>DOI: ${this['doi']}</a>`;
      // }


      if (this['image-link']) {
         // figure = `<img src="${this['image-link']}">`;
         $(figure).parents('.box').addClass('has-image');
         figure = new Image();
         let imageUrl = this['image-link'];

         let isDrive = false;

         if (imageUrl.indexOf('drive.google') >= 0) {
            // isDrive = true;
            // imageUrl = imageUrl.replace('drive.google.com/file/d/', 'drive.google.com/uc?export=view&id=');
            let imageId = imageUrl.split('drive.google.com/file/d/')[1].split('/view')[0];
            // imageUrl = imageUrl.replace('drive.google.com/file/d/', '');
            // imageUrl = imageUrl.replace('/view?usp=sharing','');
            // imageUrl = imageUrl.replace('/view?usp=drive_link','');
            imageUrl = `/proxy-image/${imageId}`;
            // let driveUrl = `https://drive.google.com/uc?export=view&id=${imageId}`;
            // let driveUrl = `https://drive.google.com/uc?id=${imageId}&authuser=1`;
            // let driveUrl = `https://drive.usercontent.google.com/download?id=${imageId}&export=view&authuser=1`;
            // fetch(driveUrl).then(function(response) {
            //    console.log(response);
            //    figure.src = driveUrl;
            //    // imageUrl = driveUrl;
            // });

            // console.log('replaced drive url', imageUrl);
         }
         // console.log(imageUrl);
         figure.onerror = function (e) {
            $(`img[src="${figure.src}"]`).parents('.box').removeClass('has-image');
            // console.error(`Failed to load image: ${imageUrl}`, e);
         }
         // if(!isDrive) {
         figure.src = imageUrl;
         // }

         if (this['image-caption']) {
            figcaption = `<figcaption>${this['image-caption']}</figcaption>`;
         }
      }

      if (this['video-link']) {
         //    this.createBlock();
         embed = '';
         // if(this['video-link'].indexOf('youtube')>=0 || this['video-link'].indexOf('youtu.be')>=0) {
         if (this['video-link'].indexOf('youtube') >= 0) {
            var embedElement = document.createElement('iframe');

            if (this['video-link'].split('v=').length < 2) return;

            let parseYoutubeId = this['video-link'].split('v=')[1];
            let ampersandPosition = parseYoutubeId.indexOf('&');
            if (ampersandPosition != -1) {
               parseYoutubeId = parseYoutubeId.substring(0, ampersandPosition);
            }
            let youtubeUrl = `https://www.youtube.com/embed/${parseYoutubeId}?enablejsapi=1`;
            embedElement.videoId = parseYoutubeId;
            embedElement.src = youtubeUrl;
            embedElement.type = 'youtube';

         } else if (this['video-link'].indexOf('vimeo') >= 0) {
            var embedElement = document.createElement('iframe');
            let parseVimeoId = this['video-link'].split('.com/')[1];

            if (parseVimeoId.indexOf('/') >= 0) {
               parseVimeoId = parseVimeoId.replaceAll('/', '?h=');
            }

            let vimeoUrl = `https://player.vimeo.com/video/${parseVimeoId}`;
            embedElement.src = vimeoUrl;
            embedElement.videoId = parseVimeoId;
            embedElement.type = 'vimeo';
         }

         if (embedElement) {
            embed = `<iframe></iframe>`;
            embedElement.dataset.url = this['video-link'];
            embedElement.width = 640;
            embedElement.height = 360;
            embedElement.frameborder = 0;
            embedElement.allow = 'autoplay; fullscreen';
            embedElement.allowfullscreen = true;
            this._embedElement = embedElement;

            $(figure).parents('.box').addClass('has-image');
            let thumbId = embedElement.videoId.replaceAll('?h=', ':');
            let figureImg = new Image();
            figureImg.src = `https://vumbnail.com/${thumbId}.jpg`
            figureImg.onerror = function () {
               // $(`img[src="${figureImg.src}"]`).parents('.box').removeClass('has-image');
            }

            embedElement.dataset.thumb = figureImg.src;

            if (!this['image-link']) {
               figure = document.createElement('div');
               figure.className = 'videothumb';
               figure.innerHTML = figureImg.outerHTML;
               figureImg.onerror = function () {
                  $(`img[src="${figureImg.src}"]`).parents('.box').removeClass('has-image');
               }
            }
         }
      }

      // sources
      // this._sources = [];
      // Object.keys(this).forEach(key => {
      //    if(key.indexOf('source')==0) {
      //       console.log(key);
      //       let sourceNum = key.split('source-')[1][0];
      //       if(sourceNum) {
      //          var sourceObj = {
      //             author_1 : this[`source-${sourceNum}-author-1-first-name`] + ' ' + this[`source-${sourceNum}-author-1-last-name'],
      //          };
      //          this._sources[sourceNum].push(sourceObj);
      //       }
      //    }
      // });

      let MAIN_html = '';
      let ASIDE_html = '';
      let contributor = '';

      title = title.replaceAll('<', '&lt').replaceAll('>', '&gt');
      authors = authors.replaceAll('<', '&lt').replaceAll('>', '&gt');

      if (sources.length > 0) {
         let sourcesHtml = '';

         const getDoiLink = (rawDoi) => {
            if (!rawDoi) return null;
            if (rawDoi.startsWith('10.')) return `https://doi.org/${rawDoi}`;
            if (rawDoi.startsWith('doi:')) return `https://${rawDoi.replace('doi:', '')}`;
            return null;
         };

         const getDoiText = (rawDoi) => {
            if (!rawDoi) return null;
            if (rawDoi.startsWith('10.')) return rawDoi;
            if (rawDoi.startsWith('doi:')) return rawDoi.replace('doi:', '');
            return null;
         };

         for (let i = 0; i < sources.length; i++) {
            const source = sources[i];

            if (!source) continue;

            const isbn_doi = isbn_dois[i];

            let doiLink = getDoiLink(isbn_doi);
            let doiText = getDoiText(isbn_doi);

            const names = source.authors || '';
            const publisher = source.publisher ? `${source.publisher}, ` : '';
            const year = source.year ? `${source.year}. ` : '';
            const titleText = source.title || '';
            const targetLink = source.link || doiLink;

            const body = `${names} <em>${titleText}</em>. ${publisher}${year}`;

            let doiAnchor = doiLink && !source.link
               ? `<a href="${doiLink}" onclick="window.open(${doiLink})" target="_blank" rel="noopener" class="bib--doi">DOI: ${doiText}</a>`
               : '';

            // ISBN/DOI display block (WorldCat or DOI)
            if (isbn_doi) {
               if (isbn_doi.startsWith('10.') || isbn_doi.startsWith('doi:')) {
                  const cleanDoi = isbn_doi.replace('doi:', '');
                  const doi_url = `https://doi.org/${cleanDoi}`;
                  doiAnchor = `<a class="ref-doi-isbn" href="${doi_url}" onclick="window.open(${doi_url})" target="_blank" rel="noopener">DOI: ${cleanDoi}</a>`;
                  // } else if (isbn_doi.match(/^\d{10}(\d{3})?$/)) {
               } else if (isbn_doi.match(/^(?:ISBN(?:-13)?:?\s*)?(?=\d{10}|\d{13}|(?:\d{1,5}[\s-]\d{1,7}[\s-]\d{1,7}[\s-][\dX]))([\d\- ]{10,17}[\dX])$/)) {
                  let isbn_url = `https://www.worldcat.org/isbn/${isbn_doi}`;
                  doiAnchor = `<a class="ref-doi-isbn" href="${isbn_url}" onclick="window.open(${isbn_url})" target="_blank" rel="noopener">ISBN: ${isbn_doi}</a>`;
               }
            }

            sourcesHtml += targetLink
               ? `<p><a href="${targetLink}" onclick="window.open(${targetLink})" target="_blank" rel="noopener">${body}</a> ${doiAnchor}</p>`
               : `<p>${body}${doiAnchor}</p>`;
         }

         ASIDE_html += `<div class='references'>${sourcesHtml}</div>`;
      }


      /*
      else {
         let sourcesObjHtml = '';
         sourcesResult.forEach((source, i) => {
            sourcesObjHtml += `<div class='source'>`;
            // sourcesObjHtml += `<div class='source'><span class='source-title'>${source.source}</span>`;
            source.authors.forEach((author, i) => {
               sourcesObjHtml += `<span class='source-author'>${author.lastName}${author.lastName&&author.firstName?', ':''}${author.firstName}</span>`;
            });
            sourcesObjHtml += `</div>`;
         });
      }
      */

      if (embed) MAIN_html += `<div class='embed'>${embed}</div>`;
      if (this.description) MAIN_html += `<p class='desc'>${this.description.replaceAll('\n\n', '<br><br>')}</p>`;

      // split links by comma
      if (this.link) {
         this.links = this.link.split(',');
         ASIDE_html += `<div class='links'>`;
         for (var i = 0; i < this.links.length; i++) {
            ASIDE_html += `<a onclick="window.open('${this.links[i]}')" href="${this.links[i]}">${this.links[i].trim()}</a>`;
         }
         ASIDE_html += `</div>`;
      }

      if (this.contribution && this.contribution == 'TRUE') {
         contributor += `<div class='contributed by'>`;
         contributor += `${this['contributor-first-name']} ${this['contributor-last-name']}`;
         if (this['title-of-contributor']) contributor += `<span>${this['title-of-contributor']}</span> `;
         if (this['link-to-contributor']) contributor += `<a href="${this['link-to-contributor']}" onclick="window.open('${this['link-to-contributor']}')">${this['link-to-contributor']}</a>`;
         contributor += `</div>`;
      }

      // media link
      if (medialink) {
         ASIDE_html += `<div class='media links'>`;
         // for(var i=0;i<this.links.length;i++) {
         ASIDE_html += `<a onclick="window.open('${medialink}')" href="${medialink}">${medialink.trim()}</a>`;
         // }
         ASIDE_html += `</div>`;
      }

      let status = `[#${idx}]`;
      /*
      let status = '';
      if(this.description) status += '<i class="desc">D</i>';
      if(authors) status += '<i class="authors">A</i>';
      if(sourcesHtml!='') status += '<i class="sources">S</i>';
      // if(sourcesObjHtml!='') status += '<i class="scholars">Sch</i>';
      if(relateds.length>0) status += `<i class="has-related">R${relateds.length-1}</i>`;
      if(embed) status += '<i class="embed">E</i>';
      */

      // ${ this._cat ? `<div class='type'>${this._cat}</div>` : ``}

      let marginVal = 200;
      let marginValX = 200;
      // let margins = `margin: ${Math.random()*marginVal}px ${Math.random()*marginVal}px ${Math.random()*marginVal}px ${Math.random()*marginVal}px;`;
      let margins = `margin: ${Math.random() * marginVal + 10}px ${Math.random() * marginVal + 10}px ${Math.random() * marginVal + 10}px ${Math.random() * marginValX + 10}px;`;
      boxCss += margins;

      // create a slug from title
      // let slug = title.toLowerCase().replaceAll(' ','-').replaceAll('.','').replaceAll(',','').replaceAll(':','').replaceAll(';','').replaceAll('!','').replaceAll('?','').replaceAll('(','').replaceAll(')','').replaceAll('/','').replaceAll('"','').replaceAll("'",'').replaceAll('&','').replaceAll('’','').replaceAll('‘','').replaceAll('“','').replaceAll('”','').replaceAll('—','-').replaceAll('–','-');
      let slug = slugify(title);
      this._slug = slug;

      let artworkType = '';
      if (this['artwork-type']) {
         artworkType = `<span class='artwork-type'>${this['artwork-type']}</span>`;
      }

      var box = $(`
         <article 
            class='box ${this._cat} ${boxClass}' 
            data-istheory="${this['quoted-in-dissertation'] == 'Y'}"
            data-id="${idx}"
            data-cat='${this._cat}'
            data-theme='${this['theme']}' 
            data-relateds="${relateds.length}" 
            id='${this._slug}' 
            style='${boxCss}'
            data-tooltip='Mouseover to show connecting entries, click to open'
         >
         ${figure ? `<figure>${figure.outerHTML}${figcaption}</figure>` : ``}
            <h3 class='title'>${title}</h3>
            ${authors ? `<div class='authors'>${authors}</div>` : ``}
            <div class='box-meta'>
               ${year ? `<div class='year'>${year}${artworkType}</div>` : `${artworkType}`}
               ${creatorsResult.length > 0 ? `<div class='creators'>${creatorsResultHtml}</div>` : ``}
               ${this['theme'] ? `<div class='theme'>${this['theme']}</div>` : ``}
            </div>
            ${/* <div class='box-body'> */ ''}
               <div class='box--main box-content'>${MAIN_html}</div>
               <div class='box--aside box-content'>${ASIDE_html}</div>
            ${/* </div> */ ''}
            <div class='status'>${status}</div>
            ${contributor}
            <a href='#close' class="close"></a>
            </article>
         `);

      this._box = box;

      $(`.boxes .boxes-inner`).append(box);
      // $(`.boxes.${this._cat} .boxes-inner`).append(box);

      if (figure) {
         $(box).addClass('has-image');

         $(box).find('img').on('error', function () {
            $(box).removeClass('has-image');
            if ($('.boxes').attr('data-view-as') == 'image') {
               $(box).css('display', 'none');
            }
         }).on('load', function () {
         });
      }

      window.entries.legitEntries.push(this);

      this.initRelateds = this.initRelateds.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.centerBox = this.centerBox.bind(this);
      // this.getReferences = this.getReferences.bind(this);
      this.setVideoInterval = this.setVideoInterval.bind(this);
      this.initYoutubePlayer = this.initYoutubePlayer.bind(this);
      this.parseBibliographyEntry = this.parseBibliographyEntry.bind(this);
      this.bindBox();
   }

   parseBibliographyEntry(entry) {
      const original = entry.trim();

      // Title: handle both "double" and 'single' quotation marks
      const quoteMatch = entry.match(/["“”‘’']([^"“”‘’']+)["“”‘’']/);
      const title = quoteMatch ? quoteMatch[1] : '';

      // Authors: anything before the title quote
      const beforeTitle = quoteMatch ? entry.substring(0, quoteMatch.index).replace(/,\s*$/, '').trim() : '';
      const authors = beforeTitle;
      const authorArray = authors
         .split(/\s+and\s+|,\s*/)
         .map(name => name.trim())
         .filter(Boolean);

      // Extract year: the last valid 4-digit number (to avoid 1940 reprints etc.)
      const yearMatch = [...entry.matchAll(/\b(16|17|18|19|20|21)\d{2}\b/g)];
      const year = yearMatch.length > 0 ? yearMatch[yearMatch.length - 1][0] : null;

      // Publisher: extract from parentheses if present
      const publisherMatch = entry.match(/\(([^()]*?,\s*(19|20)\d{2})\)/);
      let publisher = '';
      if (publisherMatch) {
         publisher = publisherMatch[1].replace(/,\s*(19|20)\d{2}$/, '').trim();
      }

      // Journal (if applicable): look for pattern like “Journal Name, 30.61–62 (2021), 230–43.”
      let journal = '';
      const journalMatch = entry.match(/,\s*([^,]+?),\s*\d{1,3}\.\d{1,3}/);
      if (journalMatch) journal = journalMatch[1].trim();

      // Volume + Issue
      const volIssueMatch = entry.match(/(\d{1,3})\.(\d{1,3})/);
      const volume = volIssueMatch ? volIssueMatch[1] : '';
      const issue = volIssueMatch ? volIssueMatch[2] : '';

      // Pages
      const pagesMatch = entry.match(/(\d{1,4})–(\d{1,4})/);
      const pages = pagesMatch ? `${pagesMatch[1]}–${pagesMatch[2]}` : '';

      // Link
      const linkMatch = entry.match(/https?:\/\/[^\s,)]+/);
      const link = linkMatch ? linkMatch[0] : '';

      // DOI
      const doiMatch = entry.match(/doi:\S+|10\.\d{4,9}\/[^\s,)]+/i);
      const doi = doiMatch ? doiMatch[0] : '';

      // or... isbn...

      return {
         authors,
         author_array: authorArray,
         title,
         year,
         publisher,
         journal,
         volume,
         issue,
         pages,
         link,
         doi: doi,
         full: original
      };
   }

   initRelateds() {
      const t = this;

      // t.totalRelatedHeight = 0;

      if (!t._relateds) return;

      t._relatedSlugs.forEach((key, index) => {

         // Assuming t._relateds contains the keys related to '.box h3' text
         // $('.box h3').each(function() {
         $('#' + key).each(function () {
            // if ($(this).text() === key) {
            if (t.relatedBoxes.indexOf(this) === -1) {
               t.relatedBoxes.push(this);
               // t.totalRelatedHeight += $(box).outerHeight(false);
            }
            // Temporarily setting visibility to hidden to calculate the total height without displaying the boxes
            // $(box).css('visibility', 'hidden');
            // $(box).attr('data-strength', t._strengths[index]);
            // $(box).css('visibility', '');
            // }
         });
      });

      // }

      if (t.relatedBoxes.length == 0) {
         t.relatedBoxes = false;
         $(t._box).addClass('no-rel');
      } else {
         $(t._box).addClass('has-rel');
      }
   }

   closeRelateds() {
      const t = this;
      // closes the relateds for this box
      this.relatedBoxes && this.relatedBoxes.forEach(function (box, index) {
         $(box).removeClass('related related-fly');
         $(box).attr('data-proxim', '');
      });

      $(t._box).removeClass('hovering');

      window.relators.splice(window.relators.indexOf(this), 1);

      // t.mouseleaves.splice(window.relators.indexOf(this), 1);
      if (window.relators.length == 0) {
         if (window.mainView) {
            window.mainView.stopLineAnimation();
         }
         this.clearRelateds();
      } else {
         // window.relators[0].centerBox(window.relators[window.relators.length-1]._box[0]);
         window.relators.forEach(rel => {
            rel.alignRelatedBoxes(rel._box, true);
         });
         // setTimeout(() => {
         // t.drawLine();
         // }, 50);
      }
      if (window.miniMap) {
         window.miniMap.update(true);
      }
   }

   clearRelateds() {
      $('.related').removeClass('related related-fly');
      $('.hovering').removeClass('hovering');
      $('body > main').removeClass('relating');
      $('.footer').addClass('in');
      clearTimeout(window.alignTimeout);
      window.relators = [];
      window.mouseovers = [];
      window.mouseleaves = [];
      if (window.mainView) {
         window.mainView.stopLineAnimation();
         window.mainView.clearLineCanvasBounds();
      }
      // $('#lines-canvas').addClass('out');
      // setTimeout(function(){
      if (window.mainView.context) {
         window.mainView.context.clearRect(0, 0, window.mainView.canvas.width, window.mainView.canvas.height);
      }
      if (window.miniMap) {
         window.miniMap.update(true);
      }
      // $('#lines-canvas').removeClass('out');
      // }, 200);
   }

   initYoutubePlayer() {
      const t = this;
      if (window.YT && window.YT.Player) {
         this._player = new YT.Player(t._embedElement, {
            origin: window.location.origin,
            videoId: t._embedElement.videoId,
            playerVars: {
               'playsinline': 1
            },
            events: {
            }
         });
      } else {
         // repeat this function until YT is defined
         setTimeout(this.initYoutubePlayer, 200);
      }
   }

   centerBox(el) {
      const main = document.querySelector('main');
      const boxes = document.querySelector('.boxes');
      const boxesInner = document.querySelector('.boxes-inner');
      const box = el;

      if (!main || !boxes || !boxesInner || !box) return;

      clearTimeout(window.isoTimeout);

      // Get the dimensions and positions of the box and boxes-inner container
      const boxRect = box.getBoundingClientRect();
      const boxesInnerRect = boxesInner.getBoundingClientRect();

      // Get the computed styles for the main element
      const mainStyle = window.getComputedStyle(main);

      function getScale(el) {
         let div = $(el).css('transform');
         var values = div.split('(')[1];
         values = values.split(')')[0];
         values = values.split(',');
         var a = values[0];
         var b = values[1];
         var scale = Math.sqrt(a * a + b * b);
         return scale;
      }

      // Extract the scaling factor from the 'transform' style of the main element
      const mainScaleMatch = getScale('main'); // mainStyle.transform.match(/scale\(([^)]+)\)/);
      const mainScale = 1; //mainScaleMatch ? mainScaleMatch : 1;

      // Get the center of the box relative to the viewport
      const boxCenterX = boxRect.left + boxRect.width / 2;
      const boxCenterY = boxRect.top + boxRect.height / 2;

      // Get the center of the viewport
      const viewportCenterX = window.innerWidth / 2;
      const viewportCenterY = window.innerHeight / 2;

      // Calculate the offset required to center the box
      let offsetX = (viewportCenterX - boxCenterX) / mainScale;
      let offsetY = (viewportCenterY - boxCenterY) / mainScale;

      // Adjust the offset to account for the fact that .boxes is centered with top: 50%, left: 50% and transform: translate3d(-50%, -50%, 0)
      const boxesCenterX = boxesInnerRect.left + boxesInnerRect.width / 2;
      const boxesCenterY = boxesInnerRect.top + boxesInnerRect.height / 2;

      offsetX += (boxesCenterX - viewportCenterX) / mainScale;
      offsetY += (boxesCenterY - viewportCenterY) / mainScale;

      // Apply the necessary translation to the viewport
      window.mainView.state.translateX = offsetX;
      window.mainView.state.translateY = offsetY;
      // window.mainView.state.scale = 0.8;
      window.mainView.updateTransform();
   }

   bindBox() {
      var t = this;
      window.mouseMoveOffset = { x: 0, y: 0 };

      // implement this._box mousedown, mousemove and mouseup for dragging
      $(this._box).on('mousedown', function (e) {
         if ($(this).hasClass('open')) {
            return;
         }

         window.isDragging = this;
         // console.log(window.isDragging);

         const left = parseFloat($(this).css('left'));
         const top = parseFloat($(this).css('top'));

         window.mouseMoveOffset.x = e.pageX - left;
         window.mouseMoveOffset.y = e.pageY - top;

         e.preventDefault();
      }).on('mousemove', (e) => {
      }).on('mouseup', () => {
         // window.isDragging = false;
         // if(hasDragged) {
         //    $(this._box).removeClass('no-hover').css({
         //       userSelect : 'auto'
         //    });
         //    setTimeout(() => {
         //       window.preventClick = false;
         //    }, 10);
         // }
      });


      $(this._box).on('mouseenter', function (e) {
         e.preventDefault();

         if (window.preventClick) { return false; }
         // if($('.box-open').length>0) { return false; }

         const _this = this;

         // if(window.doubleClicked) { return false; }

         window.mouseovers.forEach(e => {
            clearTimeout(e);
         });

         if ($(this).hasClass('no-hover')) return;

         t.mouseenter = setTimeout(function () {
            if (window.relators.indexOf(t) < 0) {
               window.hoverbox = _this;
               window.lastbox = t;

               if (t.relatedBoxes.length > 0) {
                  window.ux.guideTexts.mouseover.classList.add('ok');

                  t.alignRelatedBoxes(t._box);
                  $(hoverbox).addClass('hovering');
                  $('body > main').addClass('relating');
                  // -----------------------------------------------------------------------------
                  window.relators.push(t);
                  if (window.mainView) {
                     window.mainView.startLineAnimation();
                  }
                  // t.drawLine();
               }
            }

         }, $(this).hasClass('hovering') ? 10 : 1500);

         window.mouseovers.push(t.mouseenter);

      }).on('mouseleave', function () {
         window.mouseovers.forEach(e => {
            clearTimeout(e);
         });
         window.mouseovers = [];
         $(this).removeClass('no-hover');
      }).on('click', function (e) {
         const _this = this;
         // console.log(t);
         e.stopPropagation();
         e.preventDefault();

         // setTimeout(() => {
         //    // window.doubleClicked = false;
         //    if(!$(_this).hasClass('hovering')){
         //       window.preventClick = false;
         //       $(_this).trigger('mouseenter');
         //    }
         // }, 200);

         if (!window.preventClick) {
            window.preventClick = true;
            if ($(this).hasClass('open')) {
               return;
            }
            // t.centerBox(this);
            // let isProperZoom = window.mainView.state.scale==0.8;
            let isProperZoom = true;
            // window.mainView.state.scale = 0.8;
            // window.mainView.updateTransform();
            t.handleClick(_this);

            // if (!$('.view-as--image').is(':checked')) {
            t.centerBox(_this);
            // }

            /*
            if (!isProperZoom) {
               setTimeout(function () {
                  // if(window.miniMap) window.miniMap.update();
                  t.centerBox(_this);
                  window.preventClick = false;
               }, 500);
            } else {
               */
            setTimeout(function () {
               clearTimeout(window.isoTimeout);
            }, 100);
            setTimeout(function () {

               // if(window.miniMap) window.miniMap.update();
               window.preventClick = false;
            }, 500);
            // }
         }
      });

      $(this._box).find('.close').on('click', function (e) {
         clearTimeout(window.alignTimeout);

         window.preventClick = true;
         // setTimeout(function(){
         e.preventDefault();

         $('.box-content').hide();
         // $('.box-content').slideUp(80);
         $(t._box).removeClass('open');
         if (t._player) t._player.pause ? t._player.pause() : t._player.pauseVideo !== undefined ? t._player.pauseVideo() : '';
         if ($('.box.open').length == 0) {
            $('main').removeClass('box-open');
            $('.footer').addClass('in');

            if (window.relators.length == 0) {
               $('.hovering').removeClass('hovering');
               $('body > main').removeClass('relating');
            } else if (window.relators.length > 0) {
               for (var i = 0; i < window.relators.length; i++) {
                  $(window.relators[i]._box).addClass('hovering');
                  $('body > main').addClass('relating');
               }
            } else {
               t.closeRelateds();
               // $('.hovering').removeClass('hovering');
               // $('body > main').removeClass('relating');
            }
         }
         setTimeout(function () {
            window.preventClick = false;

            if ($('.filtered').length > 0 && window.ux) {
               $('.footer').addClass('in');
               clearTimeout(window.isoTimeout);

               window.ux.preventCenter = true;
               window.ux.applyFilters();
               setTimeout(function () {
                  window.ux.preventCenter = false;
               }, 200);
            }
         }, 200);

         // window.relators.splice(window.relators.indexOf(t), 1);

         for (var i = 0; i < window.relators.length; i++) {
            $(window.relators[i]._box).addClass('hovering');
            if (window.relators[i]) {
               window.relators[i].alignRelatedBoxes(window.relators[i]._box, true);
            }
         }
      });

      $(this._box).find('img').on('mouseenter', function (e) {
         if ($(this).parents('.box').hasClass('open')) {
            clearTimeout(window.removeZoomImage);
            // console.log(this);
            let newEl = document.createElement('div');
            $(this).clone().addClass('zoom-image').appendTo(newEl);
            $(newEl).addClass('zoom-image-container out');
            $(newEl).appendTo('body');
            setTimeout(function () {
               $('.zoom-image-container').removeClass('out');
            }, 1);
         }
      }).on('mouseleave', function (e) {
         $('.zoom-image-container').addClass('out');
         window.removeZoomImage = setTimeout(function () {
            $('.zoom-image-container').remove();
         }, 150);
      });
   }

   handleClick(el) {
      const t = this;
      // const el = el;
      // $('.box.open').removeClass('open');
      if ($('.box-open').length > 0) {
         $('.box.open .close').click();
      }
      $('body > main').addClass('relating');

      window.ux.guideTexts.open.classList.add('ok');

      // clearTimeout(window.flyDelay);
      clearTimeout(t.mouseleave);

      // setTimeout(function(){

      window.log.add(t);

      $(el).addClass('open').removeClass('related');

      window.lastbox = t;
      window.hoverbox = el;

      $('.box.open .box-content').show();

      if ($('.box.open .box-content').text().trim() == '') {
         $('.box-content').hide();
      }

      $('main').addClass('box-open relating');

      window.relators.push(lastbox);
      if (window.mainView) {
         window.mainView.startLineAnimation();
      }

      $(el).addClass('open').removeClass('related');
      // }

      this.setVideoInterval(t, el);

      // get References
      // this.getReferences(t, el);
      // window.source.getReferenceOpenBox();

      for (var i = 0; i < window.relators.length; i++) {
         window.relators[i].alignRelatedBoxes(window.relators[i]._box, true);
      }

      t.calcLineDrawRenderArea();

      clearTimeout(window.calcLineTimeout);
      window.calcLineTimeout = setTimeout(function () {
         t.calcLineDrawRenderArea();
      }, 1100);
      // console.log(leastOffsetX);

      $(el).removeClass('related');
   }

   calcLineDrawRenderArea(children = false) {
      if (!window.mainView || !window.mainView.canvas) return;
      let leastOffsetY = Infinity;
      let leastOffsetX = Infinity;
      let maxOffsetX = -Infinity;
      let maxOffsetY = -Infinity;
      const padding = 220;

      const includeBoxRect = (box) => {
         if (!box) return;
         const left = parseFloat($(box).css('left')) || 0;
         const top = parseFloat($(box).css('top')) || 0;
         const width = $(box).outerWidth(true) || 0;
         const height = $(box).outerHeight(true) || 0;
         leastOffsetX = Math.min(leastOffsetX, left);
         leastOffsetY = Math.min(leastOffsetY, top);
         maxOffsetX = Math.max(maxOffsetX, left + width);
         maxOffsetY = Math.max(maxOffsetY, top + height);
      };

      window.relators.forEach(r => {
         includeBoxRect(r._box);
         if (!r.relatedBoxes || !r.relatedBoxes.length) return;
         for (var i = 0; i < r.relatedBoxes.length; i++) {
            includeBoxRect(r.relatedBoxes[i]);
         }
      });

      if (!isFinite(leastOffsetX) || !isFinite(leastOffsetY)) return;

      window.mainView.setLineCanvasBounds({
         left: leastOffsetX - padding,
         top: leastOffsetY - padding,
         width: (maxOffsetX - leastOffsetX) + (padding * 2),
         height: (maxOffsetY - leastOffsetY) + (padding * 2)
      });
   }

   setVideoInterval(t, el) {
      var videoInterval = setInterval(function () {
         // get video player
         if (t._embedElement) {
            if (t._embedElement.type == 'youtube') {
               t.initYoutubePlayer();
               // t._player = new YouTubePlayer(t._embedElement);
               // t._player.loadVideoById(t._embedElement.videoId);
               // t._embedElement.player = t._player;
            } else if (t._embedElement.type == 'vimeo') {
               t._player = new Player(t._embedElement);
               t._player.getVideoHeight().then(h => {
                  t._player.getVideoWidth().then(w => {
                     let ratio = (h / w) * 100;
                     $(t._embedElement).parent().css('padding-bottom', ratio + '%');
                  });
               });
            }
            $('.box.open .box--main iframe').replaceWith(t._embedElement);
            let newImage = new Image();
            newImage.src = t._embedElement.dataset.thumb;
            newImage.className = 'playerthumb';
            $(newImage).appendTo($('.box.open .box--main .embed'))
            newImage.onload = async function () {
               try {
                  newImage.src = await toDataUrl(newImage);
               } catch (error) {
                  $(newImage).remove();
               }
            }

            clearInterval(videoInterval);
         } else {
            // no embedElement, remove interval
            clearInterval(videoInterval);
         }

         if (t._player) {
            // if(t._player) t._player.pause ? t._player.pause() : t._player.pauseVideo();
            clearInterval(videoInterval);

            setTimeout(function () {
               // $(box).find('.box-content').hide().slideDown(300);
               t._player.play ? t._player.play() : t._player.playVideo();
               t._player.mute ? t._player.mute() : t._player.setVolume(0); // setVolume for Vimeo
            }, 100);
         }
      }, 1000);
   }

   alignRelatedBoxes(hoverbox, immediate = false) {
      const t = this;

      // console.log('alignRelatedBoxes');

      // var tighten = $(hoverbox).hasClass('open') ? true : false;
      // -----------------------------------------------------------------------------
      const relatedBoxes = this.relatedBoxes;
      const totalRelatedHeight = this.totalRelatedHeight;

      clearTimeout(window.alignTimeout);
      window.alignTimeout = setTimeout(function () {
         window.ux.preventCenter = true;

         $('.footer').removeClass('in');
         // console.log(relatedBoxes, totalRelatedHeight, hoverbox);
         // Adjust positions based on the number of related boxes found
         var hoverboxTop = parseFloat($(hoverbox).css('top'));
         var hoverboxLeft = parseFloat($(hoverbox).css('left')) + parseFloat($(hoverbox).css('margin-left')) + parseFloat($(hoverbox).css('margin-right'));

         var hoverboxHeight = $(hoverbox).outerHeight(true);
         var hoverboxWidth = $(hoverbox).outerWidth(true);
         var currentTop = 0;

         if (relatedBoxes.length === 1) {
            // Center the single box vertically relative to the hoverbox
            currentTop = hoverboxTop + (hoverboxHeight / 2) - ($(relatedBoxes[0]).outerHeight() / 2);
         } else {
            // Assume totalRelatedHeight is calculated somewhere in your script as the total height of all related boxes
            // Center the stack of boxes vertically relative to the hoverbox
            // if(tighten==true) {
            //    currentTop = (hoverboxTop - (window.innerHeight-hoverboxHeight)*.5); // - (hoverboxHeight/2);
            // } else {
            // }
            currentTop = hoverboxTop + (hoverboxHeight * .5); // + (hoverboxHeight/2);
         }

         // sort relatedBoxes by strength
         if (relatedBoxes.length > 0) {
            // Read once, then write later to reduce layout thrash.
            const boxMetrics = new Map();
            relatedBoxes.forEach(function (box) {
               boxMetrics.set(box, {
                  width: $(box).outerWidth(false),
                  widthOuter: $(box).outerWidth(true),
                  height: $(box).outerHeight(false),
                  marginLeft: parseInt($(box).css('margin-left')) || 0,
                  top: parseInt($(box).css('top')) || 0,
                  isOpen: $(box).hasClass('open')
               });
            });

            // Position each related box
            relatedBoxes.forEach(function (box) {
               const strengths = t._strengths;
               let slug = box.id;
               let relatedIndex = t._relatedSlugs.indexOf(slug);
               let strengthValue = parseInt(strengths[parseInt(relatedIndex)], 10);
               if (isNaN(strengthValue)) strengthValue = 0;
               let proximValue = 5 - strengthValue;
               box.dataset.proxim = proximValue;
            });

            // relatedBoxes.sort(function(a, b) {
            //    return $(b).data('data-proxim') - $(a).data('data-proxim');
            // });
            // relatedBoxes.sort(function(a, b) {
            //    return parseFloat(a.dataset.proxim) - parseFloat(b.dataset.proxim);
            // });

            /*

               --------- group logic 

            */
            const columnSpacing = 130; // space between columns
            let accumulatedLeft = hoverboxLeft + hoverboxWidth + 150; // starting from main box
            // Step 1: Group boxes by proximValue (0–5)
            let grouped = {};
            let columnWidths = {}; // store widest width per proxim group
            relatedBoxes.forEach(box => {
               let proxim = parseInt(box.dataset.proxim);
               if (!grouped[proxim]) grouped[proxim] = [];
               grouped[proxim].push(box);

               if (!boxMetrics.get(box).isOpen) {
                  box.classList.add('related', 'related-fly');
               }
            });

            // Shuffle the groups to randomize their order
            Object.keys(grouped).forEach(key => {
               grouped[key] = grouped[key].sort(() => Math.random() - 0.5);
            });

            // Measure max width for each proxim group
            Object.keys(grouped).forEach(proximKey => {
               const boxes = grouped[proximKey];
               let maxWidth = 0;
               boxes.forEach(box => {
                  const width = boxMetrics.get(box).width;
                  if (width > maxWidth) maxWidth = width;
               });
               columnWidths[proximKey] = maxWidth;
            });


            // Step 2: Loop through proxim groups (0 is closest, 5 is least)
            // Object.keys(grouped).sort((a, b) => a - b).forEach((proximKey, colIndex) => {
            Object.keys(grouped).forEach((proximKey, colIndex) => {
               const boxes = grouped[proximKey];
               const proximValue = parseInt(proximKey);

               // This column’s starting left position
               let columnStart = accumulatedLeft;
               accumulatedLeft += columnWidths[proximKey] + columnSpacing; // prepare for next column

               // Vertical positioning: center group around currentTop
               // PRE-COMPUTE total height including random gaps
               const spacing = [];
               const totalHeight = boxes.reduce((sum, box, idx) => {
                  const gap = Math.random() * 50 + 20;
                  spacing.push(gap);
                  return sum + boxMetrics.get(box).height + gap;
               }, 0);
               // const totalHeight = boxes.reduce((sum, box) => sum + $(box).outerHeight(false), 0);
               let groupTop = currentTop - totalHeight / 2;

               boxes.forEach((box, idx) => {
                  // let boxLeft = hoverboxLeft + hoverboxWidth + (proximValue * 350);
                  let boxLeft = columnStart;

                  // groupTop += Math.random() * 60 + 30;
                  groupTop += spacing[idx]; // use precomputed random gap
                  let boxTop = groupTop;

                  const metrics = boxMetrics.get(box);
                  let boxWidth = metrics.width;
                  let boxHeight = metrics.height;
                  groupTop += boxHeight;

                  boxLeft -= metrics.marginLeft;

                  if (!metrics.isOpen) {

                     boxLeft += (columnWidths[proximKey] - boxWidth) / 2;
                     boxLeft += Math.random() * 120 - 60;

                     box.dataset.startX = hoverboxLeft + hoverboxWidth;
                     box.dataset.startY = metrics.top + (boxHeight / 2) + (20 * idx);

                     box.dataset.endX = hoverboxLeft + hoverboxWidth + metrics.widthOuter / 2;
                     box.dataset.endY = boxTop + (boxHeight / 2);

                     box.style.top = boxTop + 'px';
                     box.style.left = boxLeft + 'px';
                     box.style.visibility = 'visible';
                  }
               });
            });

            /*

               --------- one-column logic 

            */
            /*
            relatedBoxes.forEach(function(box, idx) {

               let proximValue = parseInt(box.dataset.proxim);
               
               let left = 0;
               let boxTop = currentTop + (30 * idx);
               boxTop -= parseInt($(box).css('margin-top'));

               if(tighten==true) {
                  left = hoverboxLeft + hoverboxWidth + Math.random()*20 + 30;
                  left += proximValue * 150;
               }
               if(tighten==false) {
                  left = hoverboxLeft + $(hoverbox).outerWidth(false) + 30;
                  left += (10 * ($('.hovering').length + 1));
                  left += proximValue * 100;
                  // left += relatedBoxLeftOffset;
               }
               
               left -= parseInt($(box).css('margin-left'));
               
               if(!$(box).hasClass('open')) {
                  $(box).addClass('related related-fly');

                  box.dataset.startX = hoverboxLeft + hoverboxWidth; // - parseInt($(box).css('margin-right')); //parseInt($(box).css('left')) + $(box).outerWidth(); // - parseInt($(box).css('margin-right'));
                  box.dataset.startY = parseInt($(box).css('top')) + ($(box).outerHeight(true) / 2) + (10 * idx);
                  
                  box.dataset.endX = hoverboxLeft + hoverboxWidth + $(box).outerWidth(true) / 2; // + $(box).outerWidth(true) / 2; // + parseInt($(box).css('margin-left'));
                  box.dataset.endY = boxTop + ($(box).outerHeight(true) / 2); // + parseInt($(box).css('margin-top'));

                  $(box).css({
                     'top': boxTop + 'px',
                     'left': tighten ? left : left + 'px', // Position to the right of the hoverbox
                     'visibility': 'visible', // Make the box visible
                  });
               }

               currentTop += $(box).outerHeight(false);
               
               // Update currentTop for the next box in the stack, including spacing between boxes
               
            });
            */


            if (window.miniMap) {
               clearTimeout(window.minimapupdate);
               window.minimapupdate = setTimeout(() => {
                  window.miniMap.update();
               }, 200);
            }

            clearTimeout(window.minimapTimeout);
            window.minimapTimeout = setTimeout(function () {
               if (window.miniMap) {
                  clearTimeout(window.minimapupdate);
                  window.minimapupdate = setTimeout(() => {
                     window.miniMap.update();
                  }, 200);
               }
            }, 1000);

            if (window.mainView) {
               window.mainView.queueCanvasResize();
            }
            // });
            // t.drawLine();

            /*
            for(var i=0; i < 50; i++) {
               setTimeout(() => { 
                  t.drawLine() 
               }, i*20);
            }
            */
         }

         window.ux.preventCenter = false;
      }, immediate ? 0 : 120);
   }
}